import classnames from 'classnames';
import RcCheckbox from 'rc-checkbox';
import { createElement } from 'react';
import './style/index.less';
RadioSelf.defaultProps = {
    prefixCls: 'im-radio',
    wrapLabel: false,
    hideBottomLine: false,
    customeStyle: true,
};
function RadioSelf(props) {
    const { className, style, customeStyle, wrapLabel, ...restProps } = props;
    const { prefixCls, children } = restProps;
    const wrapCls = classnames(`${prefixCls}-wrapper`, className);
    const mark = (createElement("label", { className: wrapCls, style: style },
        createElement(RcCheckbox, Object.assign({ className: 'custome', style: { border: '5px solid blue' } }, restProps, { type: "radio" })),
        children));
    if (wrapLabel) {
        return mark;
    }
    return createElement(RcCheckbox, Object.assign({}, props, { type: "radio" }));
}
export default RadioSelf;
